"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("../styles");

var _formElements = require("@evidation/form-elements");

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var ScrollboxComponent = _styledComponents["default"].div.withConfig({
  displayName: "Scrollbox__ScrollboxComponent",
  componentId: "agk8r3-0"
})(["overflow-y:auto;border-radius:3px;background-color:#f0f0f0;border:solid 1px #d6d6d6;padding:3px 16px;margin:15px 0 20px;&::-webkit-scrollbar{webkit-appearance:none;width:7px;}&::-webkit-scrollbar-thumb{border-radius:4px;background-color:rgba(0,0,0,0.5);webkit-box-shadow:0 0 1px rgba(255,255,255,0.5);}", ";"], function (props) {
  return props.size === "large" ? "\n      max-height: 400px;\n      ".concat([_styles.midBreakpoint], " {\n        max-height: 300px;\n      }") : "\n      max-height: 185px;\n      ".concat([_styles.midBreakpoint], " {\n        max-height: 135px;\n      }\n      ");
});

var Scrollbox = function Scrollbox(_ref) {
  var size = _ref.size,
      label = _ref.label;
  return /*#__PURE__*/_react["default"].createElement(ScrollboxComponent, {
    size: size
  }, /*#__PURE__*/_react["default"].createElement(_formElements.MarkdownHtml, null, label));
};

Scrollbox.defaultProps = {
  size: "large"
};
Scrollbox.propTypes = {
  size: _propTypes.string,
  label: _propTypes.string.isRequired
};
var _default = Scrollbox;
exports["default"] = _default;